import { configureStore } from '@reduxjs/toolkit';

import { CancellationReasonsSlice } from './cancellation-reasons/cancellation-reasons-slice';
import { ICitiesForSelectSlice } from './cities/cities-slice';
import { CoursesSlice } from './courses/courses-slice';
import { CurricularUnitsSlice } from './curricular-units/curricular-units-slice';
import { ActivityByStatusSlice } from './dashboard/dashboard-get-activity-by-status';
import { DashboardSummarySlice } from './dashboard/dashboard-get-summary.slice';
import { DashboardSlice } from './dashboard/dashboard-slice';
import { ArchivedGroupsListSlice } from './groups/archived-groups-list-slice';
import { GroupListSlice } from './groups/group-list-slice';
import { GroupSettingsSlice } from './groups/group-settings-slice';
import { GroupsSlice } from './groups/groups-slice';
import { InternshipLocationSlice } from './internship-location/internship-location-slice';
import LayoutReducer from './layouts/reducer';
import { LoadingSlice } from './load-filter/loadingSlice';
import { LoadingSelectReportSlice } from './load-select-report/loadingSelectReportSlice';
import { MenuSlice } from './menu/menu-slice';
import { OrganizationsSlice } from './organizations/organizations-slice';
import { StudentsListSlice } from './persons/students/student-list-slice';
import { ProfessionalOverviewSlice } from './professionals/professional-overview-slice';
import { ProfessionalsListsSlice } from './professionals/professionals-lists-slice';
import { ProfessionalManagementByIdSlice } from './professionals/profissional-management-slice';
import { AcademicOverviewSlice } from './reports/academic-overview-slice';
import { ActivitiesQuantityPerStudentSlice } from './reports/activites-quantity-per-student-slice';
import { ActivitiesAnalyticalPerGroupSlice } from './reports/activities-analytical-per-group-slice';
import { ActivitiesAnalyticalPerTaskSlice } from './reports/activities-analytical-per-task';
import { ActivitiesSummaryByTaskSlice } from './reports/activities-summary-by-task-slice';
import { ActivityReportInternshipSlice } from './reports/activity-report-internship';
import { AppRegisteredStudentsPerGroupSlice } from './reports/app-registered-students-per-group-slice';
import { ConsolidatedActivitiesByStudentSlice } from './reports/consolidated-activities-by-student-slice';
import { ActivitiesSummarizedByStudentSlice } from './reports/handle-activities-summarized-by-student';
import { ReportsAnalyticalActivitiesByStudentSlice } from './reports/handle-reports-analytical-activities-by-sturendt';
import { MissedActivitiesJustificationsSlice } from './reports/missed-activities-justifications-slice';
import { PerformanceReportForProfessionalsSlice } from './reports/performance-report-for-professionals-slice';
import { ProfessionalsWorkJourneySlice } from './reports/professionals-work-journey-slice';
import { RejectedByProfessionalsSlice } from './reports/rejected-by-professionals-slice';
import { ProfessionalReportSlice } from './reports/remote-professional-report';
import { StudentsIndividualWorkloadReportSlice } from './reports/students-individual-workload-report';
import { StudentsNoAppUsageSlice } from './reports/students-no-app-usage-slice';
import { StudentsWithoutRegisteringApp } from './reports/students-without-registering-app-slice';
import { SummaryReportByGroupSlice } from './reports/summary-report-by-group';
import { SummaryReportByInternshipLocation } from './reports/summary-report-by-internship-location-slice';
import { SuspectedManipulationLocationSlice } from './reports/suspected-manipulation-location-slice';
import { TeamReportListSlice } from './reports/team-report-slice-list';
import { ValidatedByProfessionalsSlice } from './reports/validated-by-professionals-slice';
import { SemestersSlice } from './semesters/semesters-slice';
import { UsersAssociatedSlice } from './users/users-associated-slice';
import { UsersOnlineSlice } from './users/users-online/users-online-slice';
import { UsersSlice } from './users/users-slice';

export const store = configureStore({
  reducer: {
    Layout: LayoutReducer,

    organizations: OrganizationsSlice.reducer,
    courses: CoursesSlice.reducer,
    curricularUnits: CurricularUnitsSlice.reducer,
    semesters: SemestersSlice.reducer,
    groups: GroupsSlice.reducer,
    dashboard: DashboardSlice.reducer,
    academicOverview: AcademicOverviewSlice.reducer,
    menu: MenuSlice.reducer,
    teamReportList: TeamReportListSlice.reducer,
    consolidatedActivitiesByStudent:
      ConsolidatedActivitiesByStudentSlice.reducer,
    professionalsList: ProfessionalsListsSlice.reducer,
    studentsList: StudentsListSlice.reducer,
    activityReportInternship: ActivityReportInternshipSlice.reducer,
    dashboardSummary: DashboardSummarySlice.reducer,
    professionalsWorkJourney: ProfessionalsWorkJourneySlice.reducer,
    studentsCHI: StudentsIndividualWorkloadReportSlice.reducer,
    activitiesQuantityPerStudent: ActivitiesQuantityPerStudentSlice.reducer,
    professionalReport: ProfessionalReportSlice.reducer,
    reportsAnalyticalActivities:
      ReportsAnalyticalActivitiesByStudentSlice.reducer,
    internshipLocation: InternshipLocationSlice.reducer,
    loadingSlice: LoadingSlice.reducer,
    loadingSelectReport: LoadingSelectReportSlice.reducer,
    activitiesAnalyticalPerTask: ActivitiesAnalyticalPerTaskSlice.reducer,
    activityByStatus: ActivityByStatusSlice.reducer,
    groupList: GroupListSlice.reducer,
    archivedGroupsList: ArchivedGroupsListSlice.reducer,
    activitiesSummarizedByStudent: ActivitiesSummarizedByStudentSlice.reducer,
    summaryReportByGroup: SummaryReportByGroupSlice.reducer,
    activitiesSummaryByTask: ActivitiesSummaryByTaskSlice.reducer,
    summaryReportByInternshipLocation:
      SummaryReportByInternshipLocation.reducer,
    users: UsersSlice.reducer,
    activitiesAnalyticalPerGroup: ActivitiesAnalyticalPerGroupSlice.reducer,
    studentsWithoutRegisteringApp: StudentsWithoutRegisteringApp.reducer,
    studentsNoAppUsage: StudentsNoAppUsageSlice.reducer,
    validatedByProfessionals: ValidatedByProfessionalsSlice.reducer,
    rejectedByProfessionals: RejectedByProfessionalsSlice.reducer,
    appRegisteredStudentsPerGroupSlice:
      AppRegisteredStudentsPerGroupSlice.reducer,
    professionalManagementById: ProfessionalManagementByIdSlice.reducer,
    professionalOverview: ProfessionalOverviewSlice.reducer,
    groupSettings: GroupSettingsSlice.reducer,
    citiesForSelect: ICitiesForSelectSlice.reducer,
    usersOnline: UsersOnlineSlice.reducer,
    usersAssociatedSlice: UsersAssociatedSlice.reducer,
    missedActivitiesJustifications: MissedActivitiesJustificationsSlice.reducer,
    performanceReportForProfessionals:
      PerformanceReportForProfessionalsSlice.reducer,
    cancellationReasons: CancellationReasonsSlice.reducer,
    suspectedManipulationLocation: SuspectedManipulationLocationSlice.reducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;

export type AppDispatch = typeof store.dispatch;
